export default __webpack_public_path__ + "static/carleaseOverview3-002a7e0e701a01cc6ad8d1c195302ce1.png";